/**
 * Which page a URL means, without a router library. `react-router-dom`
 * was in `package.json` with zero imports anywhere -- dead weight for an
 * app that, until now, was a single page. Two more pages does not
 * change that: this is a `pathname` switch, nothing more.
 *
 * Both dev (Vite's default SPA fallback) and prod (the backend's own
 * catch-all in `app.py`, guarded by `if dist.is_dir()`) already serve
 * `index.html` for any unknown path, so `/guide` and `/board` work with
 * no server change -- as long as neither collides with a prefix the dev
 * proxy or the backend's own mounts already own.
 */
export const RESERVED_PREFIXES = ["/api", "/static", "/docs", "/assets", "/auth"];

export type Page = "main" | "guide" | "board" | "doc";

export function pageFor(pathname: string): Page {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (RESERVED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) return "main";
  if (path === "/guide") return "guide";
  if (path === "/board") return "board";
  // `/doc/...` renders a doc; `/docs/...` (reserved above) is its plain text.
  if (path === "/doc" || path.startsWith("/doc/")) return "doc";
  return "main";
}
